'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/cohen.onf.ca/node_modules/querystring-es3/index.js
// module id = 745
// module chunks = 0